import { BenefitDTOBenefitEnum, DocumentsDTO } from 'probonio-shared-ui/api';
import { BenefitNavigationExtensionInterface } from '../../../../extension/interface/benefit-navigation.extension.interface';
import { BenefitMenuItemInterface } from '../../nav/BenefitMenuItem';

export class MobilityBenefitNavigationExtension extends BenefitNavigationExtensionInterface {
  getMenuItems({ documents }: { documents?: DocumentsDTO }): BenefitMenuItemInterface[] {
    const benefit = BenefitDTOBenefitEnum.Mobility.toLowerCase();
    return [
      {
        title: 'subPage.employees',
        to: `/benefits/${benefit}`,
      },
      { title: 'subPage.receipts', to: `/benefits/${benefit}/receipts` },
      { title: 'subPage.payrollReport', to: `/benefits/${benefit}/payrollReport` },
      { title: 'subPage.settings', to: `/benefits/${benefit}/settings` },
      ...(documents?.totalCount ? [{ title: 'subPage.documents', to: `/benefits/${benefit}/documents` }] : []),
    ];
  }
}
